import clsx from 'clsx';

import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModulesListPopover } from '~components/generic/module/ModulesListPopover/ModulesListPopover';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export const ModuleTabsItem = ({ data, editing, className, stable }: IEntityComponentProps) => {
  const classes = clsx({
    ...className,
    container: false,
  });
  const childModuleIds = getRelatedEntityIds(data, 'field_modules');
  const childModuleIdsLength = childModuleIds.length - 1;

  return (
    <div className={classes} id={getModuleUrlIdFromData(data.id, data.type)}>
      {editing && childModuleIds.length === 0 ? (
        <div className="container relative">
          <ModulesListPopover type={data.type} parentContext={data.id} index={0} />
        </div>
      ) : (
        <>
          {childModuleIds.map((id, i) => {
            return (
              <>
                {editing && (
                  <div className="container relative">
                    <ModulesListPopover type={data.type} parentContext={data.id} index={i} />
                  </div>
                )}
                <DraggableModuleContainer
                  parentIsStable={stable}
                  index={i}
                  key={id}
                  entityId={id}
                  parentContext={data.id}
                  parentType={data.type}
                  fieldName="relationships.field_modules.data"
                  siblingsLength={childModuleIdsLength}
                  canMove={editing}
                />
              </>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ModuleTabsItem;
